import { render } from "./RunSettings.vue?vue&type=template&id=85f14298"
import script from "./RunSettings.vue?vue&type=script&lang=js"
export * from "./RunSettings.vue?vue&type=script&lang=js"
script.render = render

export default script